module.exports = __webpack_public_path__ + "static/media/st-kilda-harbour.2cf399da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/st-kilda-harbour.jpg
// module id = 149
// module chunks = 0